<template>
  <div class="noBgUp lay7">
    <div class="version5-head">
      <HeadBannerContent
        v-if="$store.state.selected_menu"
        :itemData="$store.state.selected_menu"
      />
    </div>
    <Breadcrumb />

    <div class="container layout-outer flex-box">
      <div class="layout-left">
        <intersect @enter="animate = true">
          <h3
            class="text fadeUp"
            :class="animate ? 'animate' : ''"
            v-html="
              _.get($store.state.current_content, 'primary.0.content.title')
            "
          ></h3>
        </intersect>
        <intersect @enter="animate2 = true">
          <div
            class="layout-img-box img-box fadeUp"
            :class="animate2 ? 'animate' : ''"
            v-if="_.get(this.$store.state.current_content, 'primary')"
          >
            <picture>
              <source
                media="(max-width: 767px)"
                :srcset="
                  _.get(
                    this.$store.state.current_content,
                    'primary.0.images.0.devices.mobile'
                  )
                "
              />
              <source
                media="(max-width: 1023px)"
                :srcset="
                  _.get(
                    this.$store.state.current_content,
                    'primary.0.images.0.devices.tablet'
                  )
                "
              />
              <img
                :src="
                  _.get(
                    this.$store.state.current_content,
                    'primary.0.images.0.devices.desktop'
                  )
                "
                class="img-absolute"
                alt=""
              />
            </picture>
            <div class="img-tags flex-box wrap">
              <div
                class="img-info btn-20 bg-pink"
                v-for="(tag, index) in tagName"
                :key="index"
              >
                <span class="white noto-semibold font-12">{{ tag }}</span>
              </div>
            </div>
          </div>
        </intersect>

        <LayoutContent
          :itemData="$store.state.current_content"
          v-if="$store.state.current_content"
        />
      </div>

      <intersect @enter="animate4 = true">
        <div class="layout-right fadeUp" :class="animate4 ? 'animate' : ''">
          <div class="related-offers">
            <h4
              class="font-21 noto-semibold products-title"
              v-if="
                _.get(
                  $store.state.current_content,
                  'secondary.offersContainer.conf.useHeader'
                ) == 1
              "
            >
              {{
                _.get(
                  $store.state.current_content,
                  "secondary.offersContainer.conf.header.title"
                )
              }}
            </h4>
            <template
              v-if="
                _.get(
                  $store.state.current_content,
                  'secondary.offersContainer.data'
                )
              "
            >
              <router-link
                :to="$store.getters.getSingleUrl(item, 1)"
                class="app-link-box product-box"
                v-for="(item, index) in _.get(
                  $store.state.current_content,
                  'secondary.offersContainer.data'
                )"
                :key="index"
                v-if="
                  _.get($store.state.current_content, 'primary.0.id') !=
                    item.id && index < 3
                "
              >
                <div class="img-box">
                  <img
                    :src="_.get(item, 'cover_image.0.devices.desktop')"
                    alt
                    class="img-absolute"
                  />
                  <div class="gradient"></div>
                  <div class="box-content">
                    <h3 class="white font-21 noto-semibold">
                      {{ item.title }}
                    </h3>
                  </div>
                  <div class="btn sub bg-white">
                    {{ $fn.tr("Apply Now") }}
                  </div>
                </div>
              </router-link>
            </template>
          </div>

          <div class="offer-tags flex-box wrap">
            <router-link
              :to="$store.getters.getCategoryUrl(tag.id, 1)"
              class="btn-20 white"
              v-for="(tag, index) in tagList"
              :key="index"
              >{{ tag.title }}
            </router-link>
          </div>

          <HowToApply
            class="mt-34"
            :itemData="
              _.get(
                $store.state.current_content,
                'secondary.usefull_tools_right.conf'
              )
            "
            v-if="
              _.get(
                $store.state.current_content,
                'secondary.usefull_tools_right.conf.enabled'
              ) == 1
            "
          />
        </div>
      </intersect>
    </div>
    <ProductsSlider
      class="change-pad"
      style="margin-top: 60px"
      v-if="
        _.get(
          this.$store.state.current_content,
          'secondary.ProductsSlider.conf.enabled'
        ) == 1
      "
      :itemData="
        _.get(this.$store.state.current_content, 'secondary.ProductsSlider')
      "
    />
    <MoreWaysForBanking />
  </div>
</template>

<script>
import HeadBannerContent from "@/components/HeadBannerContent";
import Breadcrumb from "@/components/Breadcrumb";
import MoreWaysForBanking from "@/components/MoreWaysForBanking";
import HowToApply from "@/components/HowToApply";
import ProductsSlider from "@/components/ProductsSlider";
import LayoutContent from "@/components/LayoutContent";
import Intersect from "vue-intersect";

export default {
  components: {
    HeadBannerContent,
    Breadcrumb,
    MoreWaysForBanking,
    HowToApply,
    ProductsSlider,
    LayoutContent,
    Intersect
  },
  data() {
    return {
      tagId: "",
      tagName: [],
      animate: false,
      animate2: false,
      animate3: false,
      animate4: false
    };
  },

  mounted() {
    this.getTags();

    // console.log(this.tagName);
  },
  computed: {
    tagList() {
      let list = _.get( this.$store.state.current_content, 'secondary.offersContainer.data' );
      let availableTags = [];
      for (let i in list){

        if(!_.isArray(_.get(list[i], 'product_category')))continue;
        availableTags = _.concat(availableTags, list[i].product_category);
      }

      let tags = [];
      for (let i in _.get(this.$store.state.indx, "terms.product_category")){
        if(!_.includes(availableTags, _.get(this.$store.state.indx, ['terms','product_category', i, 'id'])))continue;
        tags.push( _.get(this.$store.state.indx, ['terms','product_category', i]) );
      }

      return tags;
    },
    currentIds() {
      return _.get(
        this.$store.state.current_content,
        "primary.0.product_category"
      );
    },

    availableTags(){
      let key = _.get(this.$route.params, 'path1')+'-'+_.get(this.$route.params, 'path2');
      let cached = _.get(this.$store.state.cache, key)?_.get(this.$store.state.cache, key):[];

      for (let i in this.dataByTags){
        cached.push(_.get(this.dataByTags[i], 'product_category'));
      }

      cached = _.uniq(_.flatten(cached));
      this.$store.commit('setStateDeep', { key: 'cache.'+key, val: cached })
      return cached;
    }

  },
  methods: {
    getTags: function() {
      for (let i = 0; i < this.tagList.length; i++) {
        for (let j = 0; j < this.currentIds.length; j++) {
          if (this.currentIds[j] == this.tagList[i].id) {
            this.tagName.push(this.tagList[i].title);
          }
        }
      }
    }
  }
};
</script>


